import * as THREE from 'three';
import FocusOnCmd from './FocusOnCmd';
import CommandIdEnum from '../enums/CommandIdEnums';
import CommandStack from '../logic/CommandStack';
import IParameterizable from '../interfaces/IParameterizable';
import { ModelManager } from '../model/ModelManager';
import { isProductMeshUserData } from '../interfaces/ProductMeshUserData';

export default class FocusOnBimObjectCmd extends FocusOnCmd implements IParameterizable<string> {

    #globalId: string | undefined;

    constructor(commandStack: CommandStack) {
        super(CommandIdEnum.FocusOnBimObject, commandStack, 90);
        this.commandNameResourceKey = 'command.focusOnBimObject.title';
    }

    setParameters(globalId: string): void {
        this.#globalId = globalId;
    }

    protected findTargetObject(): THREE.Object3D | undefined {
        if (!this.#globalId) {
            console.error('FocusOnBimObjectCmd: no globalId set');
            return undefined;
        }

        const modelGroup = ModelManager.getInstance().modelGroup;
        let result: THREE.Object3D | undefined;

        modelGroup.traverse((obj) => {
            if (!result && isProductMeshUserData(obj.userData) && obj.userData.product.globalId === this.#globalId) {
                result = obj;
            }
        });

        if (!result) {
            console.error(`FocusOnBimObjectCmd: BIM object not found for globalId ${this.#globalId}`);
        }

        return result;
    }
}
